/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import {
  SegmentedControl as MantineSegmentedControl,
  type MantineTheme,
  createTheme,
} from '@mantine/core';

import { colorToken } from '@fai/design-tokens';

import * as classes from './segmented-control.css';

export const segmentedControlTheme = createTheme({
  components: {
    SegmentedControl: MantineSegmentedControl.extend({
      defaultProps: {
        size: 'sm',
      },
      classNames(_, { variant }) {
        return {
          label: classes.label,
          root: variant == 'secondary' ? classes.secondaryRoot : '',
        };
      },
      vars: (_, { variant }) => {
        return {
          root:
            variant == 'secondary'
              ? {
                  '--sc-color': colorToken.color.bg.neutral.shade.base,
                  '--sc-shadow': 'none',
                }
              : {},
        };
      },
    }),
  },
}) as MantineTheme;
